import Header from '../../components/Header'
import HeaderImage from '../../images/header_bg_5.JPG'
import {  teachers } from '../../data'
import {  GrInstagram } from 'react-icons/gr'
// import {  AiOutlineTwitter } from 'react-icons/ai'
import { SiBluesky } from "react-icons/si";
// import { FaFacebook } from "react-icons/fa"
// import {  FaLinkedinIn } from 'react-icons/fa'
import Teacher from '../../components/Teacher'
import './teachers.css'

const Teachers = () => {
  return (
    <>
      <Header title="Our Teachers" image={HeaderImage}>
      Stay in touch, learn more with us.
      </Header>

      <section className='teachers'>
        <div className='container teachers__container'>
          {
            teachers.map(({id, image, name, title, socials}) => {
             return  <Teacher 
             key={id} 
             image={image} 
             name={name} 
             title={title} 
             socials={
                [
                  {icon: <GrInstagram />, link: socials[0]},
                  {icon: <SiBluesky />, link: socials[1]},
                  ]
              }/>
            })
          }
        </div>
      </section>
    </>
  )
}

export default Teachers